import React from "react";
import { ContextProviderComposer } from "../utils/ContextProvider";
import { MkIpPoolProvider } from "../contexts/MkIpPoolContext";
import { DialogProvider } from "../contexts/DialogContext";
import { NasProvider } from "../contexts/NasContext";

export const MkIpPoolComposer = ({ children }) => {
  return (
    <ContextProviderComposer
      contextProviders={[
        <MkIpPoolProvider key={0} />,
        <NasProvider key={1} />,
        <DialogProvider key={2} />,
      ]}
    >
      {children}
    </ContextProviderComposer>
  );
};
